/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:1000px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }

  $('.js-text-toggle').click(function () {
    $(this).toggleClass('open')
    $(this).parent().parent().children('.js-text').toggleClass('show')
  })

  $('.js-maker').hide()
  $('.js-product').hide()
  $('.js-estimate').change(function () {
    if ($(this).prop('checked')) {
      $(this).nextAll('.js-maker').prop('checked', true)
      $(this).nextAll('.js-product').prop('checked', true)
    } else {
      $(this).nextAll('.js-maker').removeAttr('checked').prop('checked', false).change()
      $(this).nextAll('.js-product').removeAttr('checked').prop('checked', false).change()
    }
  })

  if ($('#en-estimate').length) {
    // 初期値をベースに連番でフォーム追加
    let line = sessionStorage.getItem('line')
    var en_setNum
    if (line) {
      en_setNum = line
    } else {
      en_setNum = $('#js-product-num-set').val()
    }

    $('.js-product-line').val(en_setNum)

    $('.js-tbl-plus').click(function () {
      en_setNum++
      // sp要素追加

      if (en_setNum <= 20) {
        if (window.matchMedia('(max-width:1000px)').matches) {
          $('#estimateTblWrap--sp').append(
            `<div class="estimateTbl--sp">
        <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
            Manufacturer
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <?php echo $maker[$i] ?>
            <input type="text" name="Manufacturer${en_setNum}" id="maker${en_setNum}" placeholder="T1">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
            Part_Number<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <?php echo $product[$i] ?>
            <input type="text" name="Part_Number${en_setNum}" id="product${en_setNum}" placeholder="SN74ACT08D">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
        Quantity<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Quantity${en_setNum}" id="quantity${en_setNum}" placeholder="10">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
        Desired_unit_price<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Desired_unit_price${en_setNum}" id="price${en_setNum}" placeholder="100">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
        Desired_delivery<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data no-bd estimateTbl__line--data--en">
            <input type="text" name="Desired_delivery${en_setNum}" id="delivery${en_setNum}" placeholder="One month">
        </div>
    </div>
    </div>`
          )
        } else {
          // pc行追加
          $('#estimateTbl').append(
            `<tr><td><input type="text" id="maker${en_setNum}" name="Manufacturer${en_setNum}" placeholder="T1"></td><td><input type="text" name="Part_Number${en_setNum}" id="product${en_setNum}" placeholder="SN74ACT08D"></td><td><input type="text" name="Quantity${en_setNum}" id="quantity${en_setNum}" placeholder="10"></td><td><input type="text" name="Desired_unit_price${en_setNum}" id="price${en_setNum}" placeholder="100"></td><td><input type="text" name="Desired_delivery${en_setNum}" id="delivery${en_setNum}" placeholder="One month"></td></tr>`
          )
        }
      }
      if (en_setNum > 20) {
        en_setNum = 20
      }
      $('.js-product-line').val(en_setNum)
    })

    $('.js-tbl-delete').click(function () {
      en_setNum--
      if (en_setNum >= 1) {
        // sp要素削除
        if (window.matchMedia('(max-width:1000px)').matches) {
          $('.estimateTbl--sp:last').remove()
        } else {
          // pc行削除
          $('#estimateTbl  tbody tr:last-child').remove()
        }
      }
      if (en_setNum < 1) {
        en_setNum = 1
      }
      $('.js-product-line').val(en_setNum)
    })

    // 行数を確認ページ用にセット

    if ($('#estimateConfirm').length) {
      // ローカルストレージ行数保存
      let line = $('#line').val()
      // console.log(line)
      // 行数保存
      sessionStorage.setItem('line', line)
      // 保存地保存
      for (let num = 1; num <= line; num++) {
        sessionStorage.setItem(`maker${num}`, $('#maker' + num).val())
        sessionStorage.setItem(`product${num}`, $('#product' + num).val())
        sessionStorage.setItem(`quantity${num}`, $('#quantity' + num).val())
        sessionStorage.setItem(`price${num}`, $('#price' + num).val())
        sessionStorage.setItem(`delivery${num}`, $('#delivery' + num).val())
      }
    }
    // セッションストレージ保存分フォーム追加
    if (line) {
      $('#estimateTbl').find('td').remove()
      $('#estimateTblWrap--sp').empty()
    }
    for (let num = 1; num <= line; num++) {
      // console.log(num)
      if (window.matchMedia('(max-width:1000px)').matches) {
        $('#estimateTblWrap--sp').append(
          `<div class="estimateTbl--sp">
        <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
            Manufacturer
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Manufacturer${num}" id="maker${num}"  value="${sessionStorage.getItem(
            `maker${num}`
          )}">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
            Part_Number<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Part_Number${num}" id="product${num}" value="${sessionStorage.getItem(
            `product${num}`
          )}">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
        Quantity<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Quantity${num}" id="quantity${num}" value="${sessionStorage.getItem(
            `quantity${num}`
          )}">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
          Desired unit price<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en">
            <input type="text" name="Desired_unit_price${num}" id="price${num}" value="${sessionStorage.getItem(
            `price${num}`
          )}">
        </div>
    </div>
    <div class="estimateTbl__line flex vcenter">
        <div class="estimateTbl__line--label estimateTbl__line--label--en flex vert vcenter hcenter">
        Desired delivery<span class="req req--en">Required</span>
        </div>
        <div class="estimateTbl__line--data estimateTbl__line--data--en no-bd">
            <input type="text" name="Desired delivery${num}" id="delivery${num}" value="${sessionStorage.getItem(
            `delivery${num}`
          )}">
        </div>
    </div>
    </div>`
        )
      } else {
        $('#estimateTbl').append(
          `<tr><td><input type="text" name="Manufacturer${num}" value="${sessionStorage.getItem(
            `maker${num}`
          )}"></td><td><input type="text" name="Part_Number${num}" id="product${num}" value="${sessionStorage.getItem(
            `product${num}`
          )}"></td><td><input type="text" name="Quantity${num}" id="quantity${num}" value="${sessionStorage.getItem(
            `quantity${num}`
          )}"></td><td><input type="text" name="Desired_unit_price${num}" id="price${num}" value="${sessionStorage.getItem(
            `price${num}`
          )}"></td><td><input type="text" name="Desired delivery${num}" id="delivery${num}" value="${sessionStorage.getItem(
            `delivery${num}`
          )}"></td></tr>`
        )
      }
    }

    // サンクスページで保存値削除
    if ($('#estimateComplete').length) {
      sessionStorage.clear()
    }

    // 在庫検索ページで保存地削除
    if ($('#index').length) {
      sessionStorage.clear()
    }

    $('#submitBtn').on('click', function () {
      let error = false
      for (let num = 1; num <= en_setNum; num++) {
        const msgMakerEl = $('#maker-error-message')
        if (
          !$('#product' + num).val() ||
          !$('#quantity' + num).val() ||
          !$('#price' + num).val() ||
          !$('#delivery' + num).val()
        ) {
          msgMakerEl.html('Please fill in all required fields.')
          event.preventDefault()
          error = true
        } else {
          msgMakerEl.html('')
        }
      }

      const company = $('#form_company').val()
      const msgCompanyEl = $('#company-error-message')
      if (!company) {
        msgCompanyEl.html('Not entered.')
        event.preventDefault()
        error = true
      } else {
        msgCompanyEl.html('')
      }

      const name = $('#form_name').val()
      const msgNameEl = $('#name-error-message')
      if (!name) {
        msgNameEl.html('Not entered.')
        event.preventDefault()
        error = true
      } else {
        msgNameEl.html('')
      }

      const tel = $('#form_num').val()
      const msgTelEl = $('#tel-error-message')
      if (!tel) {
        msgTelEl.html('Not entered.')
        event.preventDefault()
        error = true
      } else if (!tel.match(/^\d{2,4}-*\d{2,4}-*\d{4}$/)) {
        // console.log('tel error: ' + tel)
        msgTelEl.html('This is not the format of a phone number.')
        event.preventDefault()
        error = true
      } else {
        msgTelEl.html('')
      }

      const mail = $('#form_mail').val()
      const msgMailEl = $('#mail-error-message')
      if (!mail) {
        event.preventDefault()
        msgMailEl.html('Not entered.')
        error = true
      } else if (!mail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/)) {
        msgMailEl.html('This is not the format of a mail address.')
        event.preventDefault()
        error = true
      } else {
        msgMailEl.html('')
      }

      const mailConf = $('#form_mail_confirm').val()
      const msgMailCofEl = $('#mail-confirm_error-message')
      if (!mailConf) {
        event.preventDefault()
        msgMailCofEl.html('Not entered.')
        error = true
      } else if (mail !== mailConf) {
        msgMailCofEl.html('Email addres does not match.')
        event.preventDefault()
        error = true
      } else {
        msgMailCofEl.html('')
      }

      if (error) {
        $(window).scrollTop($('#estimateForm').position().top)
      }
    })

    // ここから日本語
  } else {
    // 初期値をベースに連番でフォーム追加
    let line = sessionStorage.getItem('line')
    var setNum
    if (line) {
      setNum = line
    } else {
      setNum = $('#js-product-num-set').val()
    }

    $('.js-product-line').val(setNum)

    $('.js-tbl-plus').click(function () {
      setNum++
      // sp要素追加

      if (setNum <= 20) {
        if (window.matchMedia('(max-width:1000px)').matches) {
          $('#estimateTblWrap--sp').append(
            `<div class="estimateTbl--sp">
          <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              メーカー
          </div>
          <div class="estimateTbl__line--data">
              <?php echo $maker[$i] ?>
              <input type="text" name="メーカー${setNum}行目" id="maker${setNum}" placeholder="T1">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              品名<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <?php echo $product[$i] ?>
              <input type="text" name="品名${setNum}行目" id="product${setNum}" placeholder="SN74ACT08D">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              数量<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="数量${setNum}行目" id="quantity${setNum}" placeholder="10">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              希望単価<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="希望単価${setNum}行目" id="price${setNum}" placeholder="100">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              希望納期<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data no-bd">
              <input type="text" name="希望納期${setNum}行目" id="delivery${setNum}" placeholder="1か月">
          </div>
      </div>
      </div>`
          )
        } else {
          // pc行追加
          $('#estimateTbl').append(
            `<tr><td><input type="text" name="メーカー${setNum}行目" placeholder="T1" id="maker${setNum}"></td><td><input type="text" name="品名${setNum}行目" id="product${setNum}" placeholder="SN74ACT08D"></td><td><input type="text" name="数量${setNum}行目" id="quantity${setNum}" placeholder="10"></td><td><input type="text" name="希望単価${setNum}行目" id="price${setNum}" placeholder="100"></td><td><input type="text" name="希望納期${setNum}行目" id="delivery${setNum}" placeholder="1か月"></td></tr>`
          )
        }
      }
      if (setNum > 20) {
        setNum = 20
      }
      $('.js-product-line').val(setNum)
    })

    $('.js-tbl-delete').click(function () {
      setNum--
      if (setNum >= 1) {
        // sp要素削除
        if (window.matchMedia('(max-width:1000px)').matches) {
          $('.estimateTbl--sp:last').remove()
        } else {
          // pc行削除
          $('#estimateTbl  tbody tr:last-child').remove()
        }
      }
      if (setNum < 1) {
        setNum = 1
      }
      $('.js-product-line').val(setNum)
    })

    // 行数を確認ページ用にセット

    if ($('#estimateConfirm').length) {
      // ローカルストレージ行数保存
      let line = $('#line').val()
      // console.log(line)
      // 行数保存
      sessionStorage.setItem('line', line)
      // 保存地保存
      for (let num = 1; num <= line; num++) {
        sessionStorage.setItem(`maker${num}`, $('#maker' + num).val())
        sessionStorage.setItem(`product${num}`, $('#product' + num).val())
        sessionStorage.setItem(`quantity${num}`, $('#quantity' + num).val())
        sessionStorage.setItem(`price${num}`, $('#price' + num).val())
        sessionStorage.setItem(`delivery${num}`, $('#delivery' + num).val())
      }
    }
    // セッションストレージ保存分フォーム追加
    if (line) {
      $('#estimateTbl').find('td').remove()
      $('#estimateTblWrap--sp').empty()
    }
    for (let num = 1; num <= line; num++) {
      // console.log(num)
      if (window.matchMedia('(max-width:1000px)').matches) {
        $('#estimateTblWrap--sp').append(
          `<div class="estimateTbl--sp">
          <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              メーカー
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="メーカー${num}行目" id="maker${num}"  value="${sessionStorage.getItem(
            `maker${num}`
          )}">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              品名<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="品名${num}行目" id="product${num}" value="${sessionStorage.getItem(
            `product${num}`
          )}">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              数量<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="数量${num}行目" id="quantity${num}" value="${sessionStorage.getItem(
            `quantity${num}`
          )}">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              希望単価<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data">
              <input type="text" name="希望単価${num}行目" id="price${num}" value="${sessionStorage.getItem(
            `price${num}`
          )}">
          </div>
      </div>
      <div class="estimateTbl__line flex vcenter">
          <div class="estimateTbl__line--label flex vcenter">
              希望納期<span class="req">必須</span>
          </div>
          <div class="estimateTbl__line--data no-bd">
              <input type="text" name="希望納期${num}行目" id="delivery${num}" value="${sessionStorage.getItem(
            `delivery${num}`
          )}">
          </div>
      </div>
      </div>`
        )
      } else {
        $('#estimateTbl').append(
          `<tr><td><input type="text" name="メーカー${num}行目" value="${sessionStorage.getItem(
            `maker${num}`
          )}"></td><td><input type="text" name="品名${num}行目" id="product${num}" value="${sessionStorage.getItem(
            `product${num}`
          )}"></td><td><input type="text" name="数量${num}行目" id="quantity${num}" value="${sessionStorage.getItem(
            `quantity${num}`
          )}"></td><td><input type="text" name="希望単価${num}行目" id="price${num}" value="${sessionStorage.getItem(
            `price${num}`
          )}"></td><td><input type="text" name="希望納期${num}行目" id="delivery${num}" value="${sessionStorage.getItem(
            `delivery${num}`
          )}"></td></tr>`
        )
      }
    }

    // サンクスページで保存値削除
    if ($('#estimateComplete').length) {
      sessionStorage.clear()
    }

    // 在庫検索ページで保存地削除
    if ($('#index').length) {
      sessionStorage.clear()
    }

    $('#submitBtn').on('click', function () {
      let error = false
      for (let num = 1; num <= setNum; num++) {
        const msgMakerEl = $('#maker-error-message')
        if (
          !$('#product' + num).val() ||
          !$('#quantity' + num).val() ||
          !$('#price' + num).val() ||
          !$('#delivery' + num).val()
        ) {
          msgMakerEl.html('必須項目を全て入力してください。')
          event.preventDefault()
          error = true
        } else {
          msgMakerEl.html('')
        }
      }

      const company = $('#form_company').val()
      const msgCompanyEl = $('#company-error-message')
      if (!company) {
        msgCompanyEl.html('未入力です。')
        event.preventDefault()
        error = true
      } else {
        msgCompanyEl.html('')
      }

      const name = $('#form_name').val()
      const msgNameEl = $('#name-error-message')
      if (!name) {
        msgNameEl.html('未入力です。')
        event.preventDefault()
        error = true
      } else {
        msgNameEl.html('')
      }

      const ruby = $('#form_ruby').val()
      const msgRubyEl = $('#ruby-error-message')
      if (!ruby) {
        msgRubyEl.html('未入力です。')
        event.preventDefault()
        error = true
      } else {
        msgRubyEl.html('')
      }

      const tel = $('#form_num').val()
      const msgTelEl = $('#tel-error-message')
      if (!tel) {
        msgTelEl.html('未入力です。')
        event.preventDefault()
        error = true
      } else if (!tel.match(/^\d{2,4}-*\d{2,4}-*\d{4}$/)) {
        // console.log('tel error: ' + tel)
        msgTelEl.html('電話番号の形式ではありません。')
        event.preventDefault()
        error = true
      } else {
        msgTelEl.html('')
      }

      const mail = $('#form_mail').val()
      const msgMailEl = $('#mail-error-message')
      if (!mail) {
        event.preventDefault()
        msgMailEl.html('未入力です。')
        error = true
      } else if (!mail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/)) {
        msgMailEl.html('メールアドレスの形式ではありません')
        event.preventDefault()
        error = true
      } else {
        msgMailEl.html('')
      }

      const mailConf = $('#form_mail_confirm').val()
      const msgMailCofEl = $('#mail-confirm_error-message')
      if (!mailConf) {
        event.preventDefault()
        msgMailCofEl.html('未入力です。')
        error = true
      } else if (mail !== mailConf) {
        msgMailCofEl.html('一致しません。')
        event.preventDefault()
        error = true
      } else {
        msgMailCofEl.html('')
      }

      if (error) {
        $(window).scrollTop($('#estimateForm').position().top)
      }
    })
  }

  $('.js-header-search').click(function () {
    $(this).next('.headerSearch').toggleClass('show')
    return false
  })

  if (window.matchMedia('(max-width:767px)').matches) {
    // sp追加初期状態
    let total = 30
    // 件数
    let num = $('#csv_num-sp').val()
    let i1 = 0
    $('.csv-data-1-sp').each(function () {
      if (i1 > total) {
        $(this).parents('.stockBox').hide()
      } else {
        $(this).parents('.stockBox').show()
      }
      i1++
    })

    // ページ数
    let page = Math.ceil(num / total)
    // ページリンクリセット
    $('#csv-page').empty()
    // ページリンク追加
    for (let i2 = 1; i2 <= page; i2++) {
      if (i2 == 1) {
        $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter current">${i2}</a>`)
      } else {
        $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter">${i2}</a>`)
      }
    }

    $('.csv-page-link').on('click', function () {
      $('.csv-page-link').removeClass('current')
      $(this).addClass('current')
      // 現在のページ
      let current = $(this).data('id')
      // 表示件数レコード
      let show = total * current - total
      // console.log(total)
      // console.log(show)
      let record = parseInt(total) + parseInt(show)
      // console.log(record)

      let i3 = 0
      $('.csv-data-1-sp').each(function () {
        $(this).parents('.stockBox').hide()
        if (i3 >= show && i3 <= record) {
          // console.log(i3)
          $(this).parents('.stockBox').show()
        }
        i3++
      })
      $(window).scrollTop($('#stock__text').position().top)
    })
    // sp追加初期状態

    $('#csv-number').change(function () {
      // 表示数
      let total = $(this).val()
      // 件数
      let num = $('#csv_num-sp').val()
      let i1 = 0
      $('.csv-data-1-sp').each(function () {
        if (i1 > total) {
          $(this).parents('.stockBox').hide()
        } else {
          $(this).parents('.stockBox').show()
        }
        i1++
      })

      // ページ数
      let page = Math.ceil(num / total)
      // ページリンクリセット
      $('#csv-page').empty()
      // ページリンク追加
      for (let i2 = 1; i2 <= page; i2++) {
        if (i2 == 1) {
          $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter current">${i2}</a>`)
        } else {
          $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter">${i2}</a>`)
        }
      }

      $('.csv-page-link').on('click', function () {
        $('.csv-page-link').removeClass('current')
        $(this).addClass('current')
        // 現在のページ
        let current = $(this).data('id')
        // 表示件数レコード
        let show = total * current - total
        // console.log(total)
        // console.log(show)
        let record = parseInt(total) + parseInt(show)
        // console.log(record)

        let i3 = 0
        $('.csv-data-1-sp').each(function () {
          $(this).parents('.stockBox').hide()
          if (i3 >= show && i3 <= record) {
            // console.log(i3)
            $(this).parents('.stockBox').show()
          }
          i3++
        })
        $(window).scrollTop($('#stock__text').position().top)
      })
      return false
    })
  } else {
    // PC追加初期状態
    let total = 30
    // 件数
    let num = $('#csv_num').val()
    let i1 = 0
    $('.csv-data-1').each(function () {
      if (i1 > total) {
        $(this).parent('tr').hide()
      } else {
        $(this).parent('tr').show()
      }
      i1++
    })

    // ページ数
    let page = Math.ceil(num / total)
    // ページリンクリセット
    $('#csv-page').empty()
    // ページリンク追加
    for (let i2 = 1; i2 <= page; i2++) {
      if (i2 == 1) {
        $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter current">${i2}</a>`)
      } else {
        $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter">${i2}</a>`)
      }
    }

    $('.csv-page-link').on('click', function () {
      $('.csv-page-link').removeClass('current')
      $(this).addClass('current')
      // 現在のページ
      let current = $(this).data('id')
      // 表示件数レコード
      let show = total * current - total
      // console.log(total)
      // console.log(show)
      let record = parseInt(total) + parseInt(show)
      // console.log(record)

      let i3 = 0
      $('.csv-data-1').each(function () {
        $(this).parent('tr').hide()
        if (i3 >= show && i3 <= record) {
          // console.log(i3)
          $(this).parent('tr').show()
        }
        i3++
      })
      $(window).scrollTop($('#stock__text').position().top)
    })
    // PC追加初期状態

    // 表示件数切り替えとページ数切り替え
    $('#csv-number').change(function () {
      // 表示数
      let total = $(this).val()
      // 件数
      let num = $('#csv_num').val()
      let i1 = 0
      $('.csv-data-1').each(function () {
        if (i1 > total) {
          $(this).parent('tr').hide()
        } else {
          $(this).parent('tr').show()
        }
        i1++
      })

      // ページ数
      let page = Math.ceil(num / total)
      // ページリンクリセット
      $('#csv-page').empty()
      // ページリンク追加
      for (let i2 = 1; i2 <= page; i2++) {
        if (i2 == 1) {
          $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter current">${i2}</a>`)
        } else {
          $('#csv-page').append(`<a data-id="${i2}" class="csv-page-link flex vcenter hcenter">${i2}</a>`)
        }
      }

      $('.csv-page-link').on('click', function () {
        $('.csv-page-link').removeClass('current')
        $(this).addClass('current')
        // 現在のページ
        let current = $(this).data('id')
        // 表示件数レコード
        let show = total * current - total
        // console.log(total)
        // console.log(show)
        let record = parseInt(total) + parseInt(show)
        // console.log(record)

        let i3 = 0
        $('.csv-data-1').each(function () {
          $(this).parent('tr').hide()
          if (i3 >= show && i3 <= record) {
            // console.log(i3)
            $(this).parent('tr').show()
          }
          i3++
        })
        $(window).scrollTop($('#stock__text').position().top)
      })
      return false
    })
  }

  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.js-toggle').click(function () {
    $(this).next('.js-toggleBox__inner').slideToggle()
    $(this).toggleClass('open')
  })

  if ($('#stock__noresult').length) {
    $('#stockTbl').hide()
    $('.stock__num').hide()
  }

  if ($('#contactConfirm').length) {
    history.replaceState(null, null, null)
    //ブラウザバックボタン押下時
    window.addEventListener('popstate', function (e) {
      history.pushState(null, null, null)
      document.querySelector('[name="submitBack"]').click() // フォーム内の戻るボタンを押す
      return
    })
  }
})
